<template xmlns:background="http://www.w3.org/1999/xhtml">
  <div class="aside aside-left d-flex flex-column" id="kt_aside" ref="kt_aside">
    <!--begin::Brand-->
    <KTBrand></KTBrand>
    <!--end::Brand-->
    <!--begin::Nav Wrapper-->
    <div
      class="aside-nav d-flex flex-column align-items-center flex-column-fluid pt-7"
      style="background: linear-gradient(180deg, rgba(2,0,36,1) 0%, rgba(250,200,42,1) 0%, rgba(255,246,227,1) 100%);"
    >
      <!--begin::Nav-->
      <ul class="nav flex-column">
        <!--begin::Item-->
        <li
          class="nav-item mb-5"
          data-toggle="tooltip"
          data-placement="right"
          data-container="body"
          data-boundary="window"
          title="Главная"
        >
          <a
            href="../"
            class="nav-link btn btn-icon btn-icon-white btn-lg"
            data-toggle="tab"
            data-target="#kt_aside_tab_1"
            id="kt_aside_tab_1"
            role="tab"
          >
            <i class="flaticon2-protection icon-lg"></i>
          </a>
        </li>
        <!--end::Item-->

        <!--begin::Item-->
        <li
          class="nav-item mb-5"
          data-toggle="tooltip"
          data-placement="right"
          data-container="body"
          data-boundary="window"
          title="Пользователи"
        >
          <a
            href="../patients"
            class="nav-link btn btn-icon btn-icon-white btn-lg"
            data-toggle="tab"
            data-target="#kt_aside_tab_2"
            id="kt_aside_tab_2"
            role="tab"
          >
            <i class="flaticon-users-1 icon-lg"></i>
          </a>
        </li>
        <!--end::Item-->

        <!--begin::Item-->
        <!--<li
          class="nav-item mb-5"
          data-toggle="tooltip"
          data-placement="right"
          data-container="body"
          data-boundary="window"
          title="Напоминания"
        >
          <a
            href="#"
            class="nav-link btn btn-icon btn-icon-white btn-lg"
            data-toggle="tab"
            data-target="#kt_aside_tab_3"
            id="kt_aside_tab_3"
            role="tab"
          >
            <i class="flaticon2-notification icon-lg"></i>
          </a>
        </li>-->

        <!--end::Item-->

        <!--begin::Item-->
        <li
          class="nav-item mb-5"
          data-toggle="tooltip"
          data-placement="right"
          data-container="body"
          data-boundary="window"
          title="Инструкция"
        >
          <a
            href="../instruction"
            class="nav-link btn btn-icon btn-icon-white btn-lg"
            data-toggle="tab"
            data-target="#kt_aside_tab_4"
            id="kt_aside_tab_4"
            role="tab"
          >
            <i class="flaticon-presentation icon-lg"></i>
          </a>
        </li>
        <!--end::Item-->

        <!--begin::Item-->
        <li
          class="nav-item mb-5"
          data-toggle="tooltip"
          data-placement="right"
          data-container="body"
          data-boundary="window"
          title="Уведомления"
        >
          <a
            href="../notifications"
            class="nnav-link btn btn-icon btn-icon-white btn-lg"
            data-toggle="tab"
            data-target="#kt_aside_tab_5"
            id="kt_aside_tab_5"
            role="tab"
          >
            <i class="flaticon2-chat icon-lg"></i>
          </a>
        </li>
        <!--end::Item-->

        <!--begin::Item-->
        <li
          class="nav-item mb-5"
          data-toggle="tooltip"
          data-placement="right"
          data-container="body"
          data-boundary="window"
          title="FAQ"
        >
          <a
            href="../faq"
            class="nav-link btn btn-icon btn-icon-white btn-hover-text-white btn-lg"
            data-toggle="tab"
            data-target="#kt_aside_tab_6"
            id="kt_aside_tab_6"
            role="tab"
          >
            <i class="flaticon-businesswoman icon-lg"></i>
          </a>
        </li>
        <!--end::Item-->
      </ul>
      <!--end::Nav-->
    </div>
    <!--end::Nav Wrapper-->
  </div>
</template>

<style lang="scss">
/* hide default vue-bootstrap tab links */
.hide-tabs > div:not(.tab-content) {
  display: none;
}
</style>

<script>
import KTBrand from "@/view/layout/brand/Brand";
import KTLayoutAside from "@/assets/js/layout/base/aside.js";

export default {
  name: "Aside",
  components: {
    KTBrand
  },
  mounted() {
    this.$nextTick(() => {
      // Init Aside
      KTLayoutAside.init(this.$refs["kt_aside"]);
    });
  }
};
</script>
